import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/**
 * Firebase configuration — reads from environment variables.
 *
 * Create a .env file in the project root with:
 *   REACT_APP_FIREBASE_API_KEY=...
 *   REACT_APP_FIREBASE_AUTH_DOMAIN=...
 *   REACT_APP_FIREBASE_PROJECT_ID=...
 *   REACT_APP_FIREBASE_STORAGE_BUCKET=...
 *   REACT_APP_FIREBASE_MESSAGING_SENDER_ID=...
 *   REACT_APP_FIREBASE_APP_ID=...
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
